import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh2';
export const locale = {
  lang: 'zh2',
  data: {
    'ODS': {
      'TITULO': '公司简介',
      'TOOLBAR': {
        'NUEVA': '为公司创建配置文件',
        'EDITAR': '您可以修改该公司的资料数据',
        'CAMBIOS': '（更改会自动保存）',
        'DESCARGAR': '下载公司资料'
      },
      'FORMULARIOS': {
        '0': '公司信息',
        '1': '专案经理',
        '2': '人力资源总监',
        '3': '信息技术经理',
      },
      'BOTONES': {
        'BACK': '以前的',
        'NEXT': '下一个',
        'ACEPTAR': '接受'
      },
      'MODALES': {
        'EMPRESA_EXISTE': '已存在指定名称的注册公司，请尝试使用其他名称重新创建公司',
        'ERROR_GUARDADO': '创建公司时出错，请稍后重试',
        'GUARDANDO': '保存更改',
        'GENERANDO_PDF': '正在生成 PDF 文件，请稍等'
      },
      'CAMPOS': {
        'institutoEmpresa': '经纪人',
        'country_application': '经纪人国家',
        'nombreEmpresa': '公司',
        'shortName': '公司简称',
        'nombrePublicacion': '出版公司名称',
        'account_id': '帐户ID',
        'idSalesForce': '销售队伍 ID',
        'codigoProyecto': '项目代码',
        'anioFundacion': '预科年',
        'empleadosCompleto': '全职员工',
        'empleadosParcial': '兼职员工',
        'totalColaboradores': '合作者总数',
        'sector': '选择一个部门',
        'subSector': '选择子行业',
        'multinacional': '跨国',
        'name_multinational_group':'跨国集团名称',
        'region': '选择地区',
        'pais': '国家',
        'estado': '州、市或省',

        'nombreResponsable': '姓名',
        'apellidoResponsable': '姓',
        'emailResponsable': '电子邮件',
        'telResponsable': '电话',
        'extResponsable': '延期',
        'celResponsable': '移动的',

        'nombreRH': '全名',
        'emailRH': '电子邮件',
        'telRH': '电话',
        'extRH': '延期',
        'celRH': '移动的',

        'nombreTI': '全名',
        'emailTI': '电子邮件',
        'telTI': '电话',
        'extTI': '延期',
        'celTI': '移动的',

        'PDF_sector': '部门',
        'PDF_subSector': '分部门',
        'PDF_region': '地区',
        'PDF_fecha': '日期：',
        'PDF_hora': '小时：',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': '是的',
          '2': '不',
        }
      },
      'ERRORES': {
        'minlength': '您没有输入允许的最少字符数',
        'maxlength': '您已超过允许的最大字符数',
        'max': '输入的数量超过了允许的最大值',
        'min': '输入的数字小于所需的最小值',
        'pattern': '输入的文本包含此字段中不允许的字符',
        'email': '输入的文本不是正确的电子邮件格式',
        'required': '此字段是必需的',
        'TEXT_ESPEC_ANIOFUNDA':'输入的日期超过了允许的最大值',
      }
    }
  }
};
